import React, { Component, memo } from 'react'
import { SideBar } from '../../components'
import { ICONS } from '../../themes'
import { findPathUrl } from 'helpers'
import { ROUTE_PATH } from '../../helpers/constants/routes'
import { connect } from 'react-redux'
import { matchPath, withRouter } from 'react-router-dom'
import { clearSearchFilter, clearSearchTag } from '../../store/actions'
import { controller, sideBarMenuController } from '../../middleware'
import { store } from 'store'
import { isEmpty } from 'lodash'
import clearFilter from './functions/clearFilter'

class SidebarContainer extends Component {
  constructor(props) {
    super(props)
    // console.log(props)
    this.state = {
      activeMenu: '',
      menus: [],
    }
  }

  menuAllRole = [
    {
      name: 'Home',
      path: ROUTE_PATH.HOME.LINK,
      defaultIcon: 'icon-home.svg',
      activeIcon: 'icon-home-white.svg',
      onClick: () => {
        this.props.history.push(ROUTE_PATH.HOME.LINK)
      },
      isActive: () => {
        return [ROUTE_PATH.HOME.LINK]
      },
    },
  ]

  menus = {
    userManagement_buyer: {
      name: 'User Management',
      path: ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK,
      defaultIcon: 'icon-user.svg',
      activeIcon: 'icon-user-white.svg',
      onClick: () => {
        this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK)
      },
      isActive: () => {
        return [
          ROUTE_PATH.USER_MANAGEMENT_ADMIN.LINK,
          ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK,
          ROUTE_PATH.USER_DETAIL_FORM_ADMIN.LINK,
          ROUTE_PATH.USER_DETAIL_FORM_BUYER.LINK,
          ROUTE_PATH.USER_EDIT_FORM_BUYER.PATH,
        ]
      },
    },
    userManagement_admin: {
      name: 'User Management',
      path: ROUTE_PATH.USER_MANAGEMENT_ADMIN.LINK,
      defaultIcon: 'icon-user.svg',
      activeIcon: 'icon-user-white.svg',
      onClick: () => {
        this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_ADMIN.LINK)
      },
      isActive: () => {
        return [
          ROUTE_PATH.USER_MANAGEMENT_ADMIN.LINK,
          ROUTE_PATH.USER_MANAGEMENT_BUYER.LINK,
          ROUTE_PATH.USER_DETAIL_FORM_ADMIN.LINK,
          ROUTE_PATH.USER_DETAIL_FORM_BUYER.LINK,
          ROUTE_PATH.USER_EDIT_FORM_ADMIN.PATH,
        ]
      },
    },
    userManagement_supplier: {
      name: 'User Management',
      path: ROUTE_PATH.USER_MANAGEMENT_SUPPLIER.LINK,
      defaultIcon: 'icon-user.svg',
      activeIcon: 'icon-user-white.svg',
      onClick: () => {
        this.props.history.push(ROUTE_PATH.USER_MANAGEMENT_SUPPLIER.LINK)
      },
      isActive: () => {
        return [
          ROUTE_PATH.USER_MANAGEMENT_SUPPLIER.LINK,
          ROUTE_PATH.USER_DETAIL_FORM_SUPPLIER.LINK,
          ROUTE_PATH.USER_EDIT_FORM_SUPPLIER.PATH,
        ]
      },
    },
    supplierManagement_buyer: {
      name: 'Supplier Management',
      path: ROUTE_PATH.SUPPLIER_MANAGEMENT_BUYER.LINK,
      defaultIcon: 'icon-user-group.svg',
      activeIcon: 'icon-user-group-white.svg',
      onClick: () => {
        this.props.history.push(ROUTE_PATH.SUPPLIER_MANAGEMENT_BUYER.LINK)
      },
      isActive: () => {
        return [
          ROUTE_PATH.SUPPLIER_MANAGEMENT_BUYER.LINK,
          ROUTE_PATH.SUPPLIER_MANAGEMENT_FORM_BUYER.LINK,
          ROUTE_PATH.SUPPLIER_MANAGEMENT_INFORMATION_EDIT.PATH,
        ]
      },
    },
    supplierManagement_admin: {
      name: 'Supplier Management',
      path: ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK,
      defaultIcon: 'icon-user.svg',
      activeIcon: 'icon-user-white.svg',
      onClick: () => {
        this.props.history.push(ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK)
      },
      isActive: () => {
        return [
          ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK,
          ROUTE_PATH.SUPPLIER_DETAIL_FORM_ADMIN.LINK,
        ]
      },
    },
    supplierDiscovery: {
      name: 'Supplier Discovery',
      path: ROUTE_PATH.SUPPLIER_DISCOVERY.LINK,
      defaultIcon: 'icon-supplier-discovery.svg',
      activeIcon: 'icon-supplier-discovery-white.svg',
      onClick: () => {
        this.goSupplierDiscovery()
      },
      isActive: () => {
        return [
          ROUTE_PATH.SUPPLIER_DISCOVERY_INFORMATION.LINK,
          ROUTE_PATH.SUPPLIER_DISCOVERY.LINK,
        ]
      },
    },
    tipsAndTutorial: {
      name: 'User Guideline',
      path: ROUTE_PATH.RISK_MANAGEMENT.LINK,
      defaultIcon: 'icon-lamp-blue.svg',
      activeIcon: 'icon-lamp-white.svg',
      onClick: () => {
        null
      },
      isActive: () => {
        false
      },
      submenu: [
        {
          name: 'English Auction',
          path: ROUTE_PATH.RISK_MANAGEMENT.LINK,
          onClick: () => {
            this.props.history.push(
              ROUTE_PATH.TIPS_AND_TUTORIAL_ENGLISH_AUCTION.LINK
            )
          },
          isActive: () => {
            return [ROUTE_PATH.TIPS_AND_TUTORIAL_ENGLISH_AUCTION.LINK]
          },
        },
        {
          name: 'RFQ',
          path: ROUTE_PATH.RISK_MANAGEMENT.LINK,
          onClick: () => {
            this.props.history.push(ROUTE_PATH.TIPS_AND_TUTORIAL_RFQ.LINK)
          },
          isActive: () => {
            return [ROUTE_PATH.TIPS_AND_TUTORIAL_RFQ.LINK]
          },
        },
      ],
    },
    riskScore: {
      name: 'Risk Management',
      path: ROUTE_PATH.RISK_MANAGEMENT.LINK,
      // defaultIcon: 'icon-risk-score.svg',
      // activeIcon: 'icon-risk-score-white.svg',
      defaultIcon: 'icon-risk-management.svg',
      activeIcon: 'icon-risk-management-white.svg',
      onClick: () => {
        null
      },
      isActive: () => {
        false
      },
      submenu: [
        {
          name: 'Risk Level Management',
          path: ROUTE_PATH.RISK_MANAGEMENT.LINK,
          defaultIcon: 'icon-risk-score.svg',
          activeIcon: 'icon-risk-score-white.svg',
          onClick: () => {
            this.props.history.push(ROUTE_PATH.RISK_MANAGEMENT.LINK)
            clearFilter()
          },
          isActive: () => {
            return [ROUTE_PATH.RISK_MANAGEMENT.LINK]
          },
        },
        {
          name: 'Sustainability Management',
          path: ROUTE_PATH.BUYER_MANAGEMENT.LINK,
          defaultIcon: 'icon-badge.svg',
          activeIcon: 'icon-badge-white.svg',
          onClick: () => {
            this.props.history.push(ROUTE_PATH.UPLOAD_SUSTAINABILITY_BUYER.LINK)
            clearFilter()
          },
          isActive: () => [ROUTE_PATH.UPLOAD_SUSTAINABILITY_BUYER.LINK],
        },
        {
          name: 'Comprehensive Assessment Management',
          path: ROUTE_PATH.COMPREHENSIVE_ASSESSMENT_MANAGEMENT.LINK,
          defaultIcon: 'icon-check-list-checked.svg',
          activeIcon: 'icon-check-list-checked-white.svg',
          onClick: () => {
            this.props.history.push(
              ROUTE_PATH.COMPREHENSIVE_ASSESSMENT_MANAGEMENT.LINK
            )
            clearFilter()
          },
          isActive: () => [
            ROUTE_PATH.COMPREHENSIVE_ASSESSMENT_MANAGEMENT.LINK,
            ROUTE_PATH.ONLINE_TEMPLATE_MANEGEMENT.LINK,
          ],
        },
        {
          name: 'Regulatory',
          path: ROUTE_PATH.UPLOAD_REGULATORY.LINK,
          defaultIcon: 'icon-compliance.svg',
          activeIcon: 'icon-compliance-white.svg',
          onClick: () => {
            this.props.history.push(ROUTE_PATH.UPLOAD_REGULATORY.LINK)
            clearFilter()
          },
          isActive: () => [ROUTE_PATH.UPLOAD_REGULATORY.LINK],
        },
      ],
    },
    buyerManagement: {
      name: 'Buyer Management',
      path: ROUTE_PATH.BUYER_MANAGEMENT.LINK,
      defaultIcon: 'icon-user.svg',
      activeIcon: 'icon-user-white.svg',
      onClick: () => {
        this.props.history.push(ROUTE_PATH.BUYER_MANAGEMENT.LINK)
      },
      isActive: () => [
        ROUTE_PATH.BUYER_MANAGEMENT.LINK,
        ROUTE_PATH.BUYER_DETAIL_FORM.LINK,
        ROUTE_PATH.BUYER_EDIT_FORM.PATH,
      ],
    },
    companyProfile_buyer: {
      name: 'Company Profile',
      path: ROUTE_PATH.COMPANY_PROFILE_FORM_BUYER.LINK,
      defaultIcon: 'icon-company.svg',
      activeIcon: 'icon-company-white.svg',
      onClick: () => {
        this.props.history.push(ROUTE_PATH.COMPANY_PROFILE_FORM_BUYER.LINK)
      },
      isActive: () => {
        return [ROUTE_PATH.COMPANY_PROFILE_FORM_BUYER.LINK]
      },
    },
    companyProfile_supplier: {
      name: 'Company Profile',
      path: ROUTE_PATH.COMPANY_PROFILE_FORM_SUPPLIER.LINK,
      defaultIcon: 'icon-company.svg',
      activeIcon: 'icon-company-white.svg',
      onClick: () => {
        this.props.history.push(ROUTE_PATH.COMPANY_PROFILE_FORM_SUPPLIER.LINK)
      },
      isActive: () => {
        return [ROUTE_PATH.COMPANY_PROFILE_FORM_SUPPLIER.LINK]
      },
    },
    sourcing_buyer: {
      name: 'Sourcing',
      path: ROUTE_PATH.SOURCING_PROJECTS.LINK,
      defaultIcon: 'icon-sourcing.svg',
      activeIcon: 'icon-sourcing-white.svg',
      onClick: () => {
        this.props.history.push(ROUTE_PATH.SOURCING_PROJECTS.LINK)
      },
      isActive: () => {
        const pathEventEdit = findPathUrl(
          ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM_EVENT_EDIT.LINK,
          this.props
        )
        const pathProjectDetail = findPathUrl(
          ROUTE_PATH.SOURCING_PROJECT_DETAIL.LINK,
          this.props
        )
        const pathCreateNewRound = findPathUrl(
          ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM_COPYCREATE.LINK,
          this.props
        )
        const pathSourcingCompareEvents = findPathUrl(
          ROUTE_PATH.SOURCING_COMPARE_EVENTS.LINK,
          this.props
        )
        const pathSourcingCompareEvent = findPathUrl(
          ROUTE_PATH.SOURCING_COMPARE_EVENT.LINK,
          this.props
        )
        if (!isEmpty(pathEventEdit)) {
          return [pathEventEdit.url]
        } else if (!isEmpty(pathProjectDetail)) {
          return [pathProjectDetail.url]
        } else if (!isEmpty(pathCreateNewRound)) {
          return [pathCreateNewRound.url]
        } else if (!isEmpty(pathSourcingCompareEvents)) {
          return [pathSourcingCompareEvents.url]
        } else if (!isEmpty(pathSourcingCompareEvent)) {
          return [pathSourcingCompareEvent.url]
        } else {
          return [
            ROUTE_PATH.SOURCING_BUYER.LINK,
            ROUTE_PATH.SOURCING_PROJECTS.LINK,
            ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM.LINK,
            ROUTE_PATH.SOURCING_DETAIL_BUYER_FORM_EDIT.LINK,
          ]
        }
      },
    },
    sourcing_supplier: {
      name: 'Sourcing',
      path: ROUTE_PATH.SOURCING_SUPPLIER.LINK,
      defaultIcon: 'icon-sourcing.svg',
      activeIcon: 'icon-sourcing-white.svg',
      onClick: () => {
        this.props.history.push(ROUTE_PATH.SOURCING_SUPPLIER.LINK)
      },
      isActive: () => {
        return [
          ROUTE_PATH.SOURCING_SUPPLIER.LINK,
          ROUTE_PATH.SOURCING_DETAIL_SUPPLIER_FORM.LINK,
        ]
      },
    },
    regulatory: {
      name: 'Regulatory',
      path: ROUTE_PATH.UPLOAD_REGULATORY.LINK,
      defaultIcon: 'icon-compliance.svg',
      activeIcon: 'icon-compliance-white.svg',
      onClick: () => {
        this.props.history.push(ROUTE_PATH.UPLOAD_REGULATORY.LINK)
      },
      isActive: () => [ROUTE_PATH.UPLOAD_REGULATORY.LINK],
    },
  }

  listMenu = {
    menuBuyerAdmin: [
      ...this.menuAllRole,
      // this.menus.companyProfile_buyer,
      this.menus.userManagement_buyer,
      this.menus.supplierManagement_buyer,
      this.menus.supplierDiscovery,
      // this.menus.sustainability,
      // this.menus.comprehensive,
      this.menus.riskScore,
      // this.menus.sourcing_buyer,
    ],

    menuBuyer: [...this.menuAllRole, this.menus.supplierDiscovery],
    menuAdmin: [
      ...this.menuAllRole,
      this.menus.userManagement_admin,
      this.menus.buyerManagement,
      this.menus.supplierManagement_admin,
    ],
    menuRiskManagement: [
      ...this.menuAllRole,
      this.menus.supplierManagement_buyer,
      this.menus.supplierDiscovery,
      // this.menus.sustainability,
      // this.menus.comprehensive,
      this.menus.riskScore,
    ],
    menuSupplier: [
      ...this.menuAllRole,
      this.menus.companyProfile_supplier,
      // this.menus.userManagement_supplier,
      this.menus.sourcing_supplier,
      this.menus.tipsAndTutorial,
    ],
  }

  findActivePathUrl = (paths = []) => {
    return paths.includes(location.pathname)
  }

  goSupplierDiscovery = () => {
    this.props.history.push(ROUTE_PATH.SUPPLIER_DISCOVERY.LINK)
    if (this.props.location.pathname != ROUTE_PATH.SUPPLIER_DISCOVERY.LINK) {
      store.dispatch(clearSearchFilter())
      store.dispatch(clearSearchTag())
    }
    // store.dispatch(clearSearchFilter())
    // store.dispatch(clearSearchTag())
  }

  renderMenuWithRole = () => {
    const { user } = this.props
    const {
      menuAdmin,
      menuBuyer,
      menuBuyerAdmin,
      menuSupplier,
      menuRiskManagement,
    } = this.listMenu

    // console.log(user.roles)

    if ('role' in user && user.role !== '') {
      switch (user.role) {
        case 1:
          this.renderSidebar(menuAdmin)
          break
        case 2:
          this.renderSidebar(menuBuyerAdmin)
          break
        case 3:
          this.renderSidebar(menuBuyerAdmin)
          break
        case 4:
          this.renderSidebar(menuBuyer)
          break
        case 5:
          this.renderSidebar(menuSupplier)
          break
        case 6:
          this.renderSidebar(this.state.menuSupplierAdmin)
          break
        case 7:
          this.renderSidebar(menuRiskManagement)
          break
        default:
          console.log('No role')
          break
      }
    } else if (!!user && 'roles' in user) {
      let menu = [...this.menuAllRole]
      user.roles.map((e, i) => {
        //System Admin
        if (e.id === 2) {
          const adminMenu = [
            this.menus.companyProfile_buyer,
            this.menus.userManagement_buyer,
            this.menus.supplierManagement_buyer,
            this.menus.supplierDiscovery,
            this.menus.riskScore,
            this.menus.regulatory,
            // this.menus.sustainability,
            // this.menus.comprehensive,
            this.menus.supplierDiscovery,
            this.menus.sourcing_buyer,
          ]
          menu = this.arrayUnique(menu.concat(adminMenu))
        }
        //Admin
        if (e.id === 3) {
          const adminMenu = [
            this.menus.companyProfile_buyer,
            this.menus.userManagement_buyer,
            this.menus.supplierManagement_buyer,
            this.menus.supplierDiscovery,
            this.menus.riskScore,
            this.menus.regulatory,
            // this.menus.sustainability,
            // this.menus.comprehensive,
            this.menus.supplierDiscovery,
            this.menus.sourcing_buyer,
          ]
          menu = this.arrayUnique(menu.concat(adminMenu))
        }
        //User
        if (e.id === 4) {
          const userMenu = [this.menus.supplierDiscovery]
          menu = this.arrayUnique(menu.concat(userMenu))
        }
        //Risk
        if (e.id === 7) {
          const riskMenu = [
            this.menus.supplierManagement_buyer,
            this.menus.supplierDiscovery,
            this.menus.riskScore,
            // this.menus.sustainability,
            // this.menus.comprehensive,
          ]
          menu = this.arrayUnique(menu.concat(riskMenu))
        }
        //Purchaser
        if (e.id === 8) {
          const purchaserMenu = [
            this.menus.supplierManagement_buyer,
            this.menus.supplierDiscovery,
            this.menus.sourcing_buyer,
          ]
          menu = this.arrayUnique(menu.concat(purchaserMenu))
        }
        //Approver
        if (e.id === 9) {
          const approverMenu = [
            this.menus.supplierDiscovery,
            this.menus.sourcing_buyer,
          ]
          menu = this.arrayUnique(menu.concat(approverMenu))
        }
        // TEC
        if (e.id === 10) {
          const tecMenu = [this.menus.sourcing_buyer]
          menu = this.arrayUnique(menu.concat(tecMenu))
        }
        // Observer
        if (e.id === 11) {
          const observerMenu = [this.menus.sourcing_buyer]
          menu = this.arrayUnique(menu.concat(observerMenu))
        }
      })

      try {
        const obj = controller().checkRole(user.roles)
        let arrayMenu = sideBarMenuController().asset(obj, menu)
        arrayMenu = this.arrayUnique(arrayMenu)
        return this.renderSidebar(arrayMenu)
      } catch (error) {
        console.log(error)
      }
    }
  }

  getActiveMenu(_menu = []) {
    let activeMenu = null
    let curPath = location.pathname
    for (let m of _menu) {
      if (m) {
        if (m.submenu) {
          activeMenu = Array.from(m.submenu).find(sm => {
            return sm.isActive().some(path => matchPath(curPath, { path }))
          })
        } else {
          if (m.isActive().some(path => matchPath(curPath, { path }))) {
            activeMenu = m
          }
        }

        if (activeMenu) {
          return activeMenu.name
        }
      }
    }

    return activeMenu
  }

  arrayUnique(array) {
    return [...new Set(array)]
  }

  renderSidebar = (_menu = []) => {
    _menu = Array.from(_menu).filter(m => !!m)
    this.setState({ menus: _menu, activeMenu: this.getActiveMenu(_menu) })
  }

  refreshActiveMenu(defaultMenu = null) {
    const newActiveMenu = this.getActiveMenu(this.state.menus)
    this.setState({ activeMenu: defaultMenu || newActiveMenu })
  }

  removeHistoryListener() {}

  componentDidMount() {
    this.renderMenuWithRole()
    this.removeHistoryListener = this.props.history.listen(location => {
      this.refreshActiveMenu()
    })
  }

  componentWillUnmount() {
    this.removeHistoryListener()
  }

  render() {
    const activeMenu = this.getActiveMenu(this.state.menus)

    return (
      <SideBar>
        {this.state.menus.map((m, i) => {
          return !m ? null : (
            <SideBar.Item
              submenu={m.submenu}
              key={m.name + i}
              defaultIconSrc={ICONS[m.defaultIcon]}
              activeIconSrc={ICONS[m.activeIcon]}
              name={m.name}
              onClick={m.onClick}
              activeKey={activeMenu}
            >
              {m.name}
            </SideBar.Item>
          )
        })}
      </SideBar>
    )
  }
}

const mapStateToProps = state => {
  // console.log(state)
  return {
    user: state.user,
    role: state.role,
  }
}

export default connect(mapStateToProps)(withRouter(SidebarContainer))
